'use client';

import { useRouter } from 'next/navigation';
import { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface BackButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onBackClick?: () => void;
}

export function BackButton({
  children,
  className,
  onBackClick,
  ...props
}: BackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      router.back();
    }
  };

  return (
    <button onClick={handleClick} className={cn(className)} {...props}>
      {children}
    </button>
  );
}
